// extracted by mini-css-extract-plugin
export default {"createProjectPage":"CreateProject_createProjectPage__pvKMi"};